import { LocationQueryValue } from 'vue-router';
import { ConstantParams } from '@/store/types';

type QueryValue = LocationQueryValue | LocationQueryValue[] | undefined;

const firstValue = (value: QueryValue): string => {
  const raw = Array.isArray(value) ? value[0] : value;
  return raw ?? '';
};

const safeDecode = (raw: string): string => {
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

const tryParse = (raw: string): Record<string, unknown> | null => {
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

const isFilled = (value: unknown): value is string => typeof value === 'string' && !!value;

// con_str от родителя: {"Name_app":"...","TK":"GUID","IMEI":"...","id_login":number}
export const parseConStr = (value: QueryValue): ConstantParams | null => {
  const raw = firstValue(value);
  if (!raw) return null;
  // Родитель может прислать con_str как сырым JSON, так и дважды закодированным
  const parsed = tryParse(raw) ?? tryParse(safeDecode(raw));
  if (!parsed) return null;

  const {
    Name_app, TK, IMEI, id_login,
  } = parsed;
  const idLogin = Number(id_login);
  if (!isFilled(Name_app) || !isFilled(TK) || !isFilled(IMEI) || !idLogin) return null;

  return {
    Name_app,
    TK,
    IMEI,
    id_login: idLogin,
  };
};

export const parseIdPatient = (value: QueryValue): number => {
  const id = Number(firstValue(value));
  return Number.isInteger(id) && id > 0 && id <= 2147483647 ? id : 0;
};
